import { render, staticRenderFns } from "./MapArc.vue?vue&type=template&id=456dd6c2&scoped=true&"
import script from "./MapArc.vue?vue&type=script&lang=js&"
export * from "./MapArc.vue?vue&type=script&lang=js&"
import style0 from "./MapArc.vue?vue&type=style&index=0&id=456dd6c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456dd6c2",
  null
  
)

export default component.exports